import { atom } from "jotai";

export type User = {
  name: string;
  age: number;
  loan_term: number;
  requested_loan: number;
  credit_score: number;
  annual_income: number;
  debt: number;
  bgcolor: string;
};


export type PredictResponse = {
  prediction: number;
  chu: {
    min: number;
    max: number;
  };
  advice: string;
};

export const LoadingAtom = atom(false)
export const PredictDataAtom = atom<PredictResponse | null>(null);